
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import GroupIcon from '@mui/icons-material/Group';


const VendorMgmt = {
  id: '13',
  title: 'Vendor Mgmt',
  type: 'group',
  role: 'PHARMA_OMS_MANAGER',
  children: [
    {
      id: 'designvendor',
      title: 'Design Vendor',
      type: 'item',
      url: '/designvendor',
      icon: AddPhotoAlternateIcon
    },{
      id: 'rmvendor',
      title: 'RM Vendor',
      type: 'item',
      url: '/rmvendor',
      icon: GroupIcon
    },
  ]
};

export default VendorMgmt;